import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import dayjs from 'dayjs';
import fetchAPI from 'utils/http/fetchAPI';
import { getWorkerTimeout } from 'utils/work/waitForWorkRequest';
import { registerWorkerTask } from 'redux/actions/backendStatus';
var getExtraTimeoutSeconds = function getExtraTimeoutSeconds() {
  var _workerResponse$name$, _workerResponse$name, _workerResponse$name$2;
  var workerResponse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var workerName = (_workerResponse$name$ = workerResponse === null || workerResponse === void 0 || (_workerResponse$name = workerResponse.name) === null || _workerResponse$name === void 0 || (_workerResponse$name$2 = _workerResponse$name.toLowerCase) === null || _workerResponse$name$2 === void 0 ? void 0 : _workerResponse$name$2.call(_workerResponse$name)) !== null && _workerResponse$name$ !== void 0 ? _workerResponse$name$ : '';
  var needsExtraTimeout = ['biggest-worker', 'bigger-worker'].some(function (workerNameFragment) {
    return workerName.includes(workerNameFragment);
  });
  return needsExtraTimeout ? 180 : 0;
};
var dispatchWorkRequest = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(experimentId, body, timeout, ETag, broadcast, fileName, dispatch) {
    var taskName, workerTimeoutDate, requestTime, request, response, _ref2, _ref2$workerGpuType, workerGpuType, extraTimeoutSeconds;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          taskName = body.name; // for listGenes, markerHeatmap, & getEmbedding we set a long timeout for the worker
          // after that timeout the worker will skip those requests
          // meanwhile in the UI we set a shorter timeout. The UI will be prolonging this timeout
          // as long as it receives "heartbeats" from the worker because that means the worker is alive
          // and progresing.
          // this should be removed if we make each request run in a different worker
          workerTimeoutDate = getWorkerTimeout(taskName, timeout);
          requestTime = dayjs().toISOString();
          request = {
            experimentId: experimentId,
            ETag: ETag,
            timeout: workerTimeoutDate,
            requestTime: requestTime,
            body: body,
            // TODO, rather than doing this, see if we can get rid of requestProps
            // in the workers and just send broadcast true or false
            requestProps: {
              broadcast: broadcast
            },
            fileName: fileName
          };
          _context.next = 6;
          return fetchAPI("/v2/workRequest/".concat(experimentId), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(request)
          });
        case 6:
          response = _context.sent;
          // The API decides whether a task runs on GPU (big worker + a task with a GPU
          // implementation), so take the answer from its response instead of re-deriving the
          // routing rules here - that's the one place that knows them. This is what lets a queued
          // request find the worker it is waiting behind.
          _ref2 = response !== null && response !== void 0 ? response : {}, _ref2$workerGpuType = _ref2.workerGpuType, workerGpuType = _ref2$workerGpuType === void 0 ? null : _ref2$workerGpuType;
          if (workerGpuType !== null) dispatch(registerWorkerTask(experimentId, taskName, workerGpuType));

          // waitForWorkRequest attributes heartbeats to a worker, so it needs to know ours.
          request.workerGpuType = workerGpuType;

          // adding extra timeout for bigger workers
          extraTimeoutSeconds = getExtraTimeoutSeconds(response);
          request.timeout = getWorkerTimeout(taskName, timeout, extraTimeoutSeconds);
          return _context.abrupt("return", request);
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function dispatchWorkRequest(_x, _x2, _x3, _x4, _x5, _x6, _x7) {
    return _ref.apply(this, arguments);
  };
}();
export default dispatchWorkRequest;